<header class="mat-display-1 pt-3 mb-3">
  <ng-content></ng-content>
</header>
<mat-divider class="bdg-page-header-divider mb-4"></mat-divider>
